import { useAuth } from '@/contexts/AuthContext';
import { useProfile } from '@/hooks/useProfile';

export function useCurrentUser() {
  const { user } = useAuth();
  const { profile } = useProfile();
  const isTrainerRole = profile?.role === 'trainer' || user?.user_metadata?.role === 'trainer';
  
  return {
    user,
    profile,
    isTrainer: isTrainerRole,
    role: profile?.role || user?.user_metadata?.role || 'user'
  };
}